import React from 'react'
import { useTranslation } from 'react-i18next'

import { Chip } from '@/components/Chip/Chip'
import { Card } from '@/components/ui/card'
import type { IPersonalityInsight } from '@/store/api/Person/Person.types'

import { EmptyStateCard, EmptyStateCardIcon } from './EmptyStateCard'

interface PersonalityInsightsWidgetTypes {
  personalityInsights?: IPersonalityInsight[]
}

export const PersonalityInsightsWidget = ({
  personalityInsights,
}: PersonalityInsightsWidgetTypes) => {
  const { t } = useTranslation()

  return (
    <Card className="flex flex-col bg-baseColor p-4 gap-4">
      <p className="flex text-neutralColor text-xl font-medium">
        {t('report.generalInfo.personalityInsights')}
      </p>
      {personalityInsights?.length !== 0 ? (
        <div className="flex gap-3 flex-wrap items-start">
          {personalityInsights?.map((insight, index) => (
            <Chip
              text={insight.trait}
              key={index}
              variant="blue"
              size="medium"
            />
          ))}
        </div>
      ) : (
        <EmptyStateCard
          title={t('report.generalInfo.personalityInsightsEmpty')}
          icon={EmptyStateCardIcon.PERSON}
        />
      )}
    </Card>
  )
}
